interface WigEmoticonProps {
  className?: string;
}

function WigEmoticon({ className = '' }: WigEmoticonProps) {
  return (
    <div
      className={`relative inline-flex items-center justify-center w-10 h-10 rounded-full bg-rose-600 shadow-sm ${className}`}
      aria-hidden="true"
    >
      <span className="text-xl font-bold text-white leading-none">W</span>
      <span className="absolute -top-[3px] text-rose-200 text-lg leading-none select-none">◠</span>
    </div>
  );
}

export default WigEmoticon;
